import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { StatesDTO } from "./states.dto";

export class AllStatesResponseModel extends GlobalResponseObject {
    data?: StatesDTO[];
}